import { CSSProperties } from 'react'

import { convertParameterPropertiesToCssProperties } from '@helpers'
import { PARAMETER_KEY } from '@constants'
import { ColumnParametersType } from '@types'

export const getCssPropertiesFromColumnParameters = (data: {
  parameters?: ColumnParametersType | undefined
  useParameters?: boolean
}) => {
  const { parameters, useParameters } = data

  let headerCssProperties: CSSProperties = {}
  let textCssProperties: CSSProperties = {}

  if (useParameters && parameters?.length) {
    const viewHeaderParameters = parameters?.find(
      parameterData => parameterData.paramKey === PARAMETER_KEY.HEADER
    )?.param
    const viewTextParameters = parameters?.find(
      parameterData => parameterData.paramKey === PARAMETER_KEY.TEXT
    )?.param

    if (viewHeaderParameters?.properties?.length) {
      headerCssProperties = convertParameterPropertiesToCssProperties(
        viewHeaderParameters?.properties
      )
    }

    if (viewTextParameters?.properties?.length) {
      textCssProperties = convertParameterPropertiesToCssProperties(viewTextParameters?.properties)
    }
  }

  return {
    headerCssProperties,
    textCssProperties,
  }
}
